<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-payment-modal-frozen></app-payment-modal-frozen>